<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <el-input
        v-model="cargoDoc.notifyCode"
        :disabled="disabled"
        style="flex:1"
      />
      <cargo-advance-select
        :disabled="disabled"
        :select-type="selectTypeNames.basic_data_Company"
        :method-params="{ notify: true, active: true }"
        filterable
        :default-value="cargoDoc.notifyId||''"
        style="flex:1"
        @parentCallBack="notifyAutoCompleteChange"
      />
    </div>
    <div style="margin-top: 5px">
      <el-button
        type="primary"
        :disabled="disabled"
        @click="onClear"
      >{{ $t('SeaExport.Reset') }}
      </el-button>
      <el-button
        type="primary"
        :disabled="disabled"
        style="margin-left: 5px"
        @click="onCopyConsignee(false)"
      >{{ $t('SeaExport.CopyTheConsignee') }}
      </el-button>
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="cargoDoc['notifyLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      :filter-chars="false"
      style="margin-top: 5px"
      @change="onChange('notifyLine'+i)"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'SeSubBillNotify',
  components: { cargoInput, cargoAdvanceSelect },
  props: {
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.cargoDoc[key] }])
    },
    async notifyAutoCompleteChange(data) {
      const form = this.cargoDoc
      form.notifyId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyNotifyManifestAddress(form, data)
      } else {
        CargoDocUtil.onClear(form, 3)
      }
      this.changeAllItem(form)
    },
    onClear() {
      CargoDocUtil.onClear(this.cargoDoc, 3)
      this.changeAllItem(this.cargoDoc, ['notifyId'])
    },
    changeAllItem(form, ignoreKeys = []) {
      const items = []
      if (!ignoreKeys.includes('notifyCode')) {
        items.push({ key: 'notifyCode', value: form.notifyCode })
      }
      if (!ignoreKeys.includes('notifyId')) {
        items.push({ key: 'notifyId', value: form.notifyId })
      }
      for (let i = 1; i <= 7; i++) {
        if (!ignoreKeys.includes(`notifyLine${i}`)) {
          items.push({ key: `notifyLine${i}`, value: form[`notifyLine${i}`] })
        }
      }
      this.$emit('childrenChange', items)
    },
    // 抄录收货人
    onCopyConsignee(detail) {
      const form = this.cargoDoc
      form.notifyCode = form.consigneeCode
      form.notifyLine1 = form.consigneeLine1
      form.notifyLine2 = form.consigneeLine2
      form.notifyLine3 = form.consigneeLine3
      if (detail) {
        form.notifyCountry = form.consigneeCountry
        form.notifyCity = form.consigneeCity
        form.notifyProvince = form.consigneeProvince
        form.notifyZipCode = form.consigneeZipCode
        form.notifyMobile = form.consigneeMobile
        form.notifyEmail = form.consigneeEmail
        form.notifyFax = form.consigneeFax
        form.notifyContact = form.consigneeContact
      } else {
        form.notifyLine4 = form.consigneeLine4
        form.notifyLine5 = form.consigneeLine5
        form.notifyLine6 = form.consigneeLine6
        form.notifyLine7 = form.consigneeLine7
      }
      this.changeAllItem(form, ['notifyId'])
    }
  }
}
</script>
